import Chip from './Chip';

export default Chip;
export * from './Chip.theme';
